import type { UpdateUserAttributeOutput } from 'aws-amplify/auth';
import { Auth } from '~/amplify';
import { CONFIRM_ATTRIBUTE_WITH_CODE } from '~/amplify/constants';
import { PHONE_NUMBER_ATTRIBUTE_KEY } from '~/components/page/Auth/constants';

const sendPhoneVerificationCode = async (result: UpdateUserAttributeOutput) => {
  // In this case the code will be sent automatically, do nothing
  if (result.nextStep.updateAttributeStep === CONFIRM_ATTRIBUTE_WITH_CODE) {
    return;
  }

  await Auth.sendUserAttributeVerificationCode({
    userAttributeKey: PHONE_NUMBER_ATTRIBUTE_KEY,
  });
};

export default sendPhoneVerificationCode;
